import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { publishedLegalPages } from '@wanderlust/shared';
import { PrivacySettingsLink } from '../consent/PrivacySettingsLink';

/**
 * Each legal page as its own footer link, then the privacy settings control.
 * Counsel asked for every policy to be linked separately at the foot of the
 * home page; the same row is on every footer that carried the privacy link. The
 * settings control stays a control, not a stand-in for the policy.
 */
export function LegalLinks({
  className = '',
  linkClassName,
  separatorClassName = '',
}: {
  className?: string;
  linkClassName: string;
  separatorClassName?: string;
}) {
  return (
    <nav aria-label="Legal" className={className}>
      <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
        {publishedLegalPages().map((page) => (
          <Fragment key={page.key}>
            <li>
              <Link to={page.path} className={linkClassName}>
                {page.label}
              </Link>
            </li>
            <li aria-hidden="true" className={separatorClassName}>
              &bull;
            </li>
          </Fragment>
        ))}
        <li>
          <PrivacySettingsLink className={linkClassName} />
        </li>
      </ul>
    </nav>
  );
}
